const selConfig = {
  name:'type',
  required:true,
  label:'规则类型'
}

const options = [
  {
    label:'允许',
    value:'1'
  },
  {
    label:'拒绝',
    value:'0'
  }
]

const disConfig = {
  name:'reject_all',
  required:true,
  label:'是否全部区域'
}

const disOptions = [
  {
    label:'全部区域',
    value:'1'
  },
  {
    label:'部分区域',
    value:'0'
  }
]

const provinceConfig = {
  name:'invite_province',
  required:true,
  rules:[{ required: true, message: '请选择省！' }]
}

const cityConfig = {
  name:'invite_city',
}

const areaConfig = {
  name:'invite_area',
}

const invProvinceConfig = {
  name:'invitee_province',
  required:true,
  rules:[{ required: true, message: '请选择省！' }]
}

const invCityConfig = {
  name:'invitee_city',
}

const invAreaConfig = {
  name:'invitee_area',
}

const initialVal = {
  reject_all:'1',
  invite_limit:'1'
}

const numConfig = {
  label:'每人每月可邀请次数（次）',
  name:'invite_limit',
  required:true,
  rules:[{ required: true, message: '请输入可邀请次数！' }]
}

export {
  selConfig,
  options,
  disOptions,
  disConfig,
  provinceConfig,
  cityConfig,
  areaConfig,
  invProvinceConfig,
  invCityConfig,
  invAreaConfig,
  initialVal,
  numConfig
}